// material-ui
import { Box, useMediaQuery, useTheme } from '@mui/material';

// project-imports
// import NavUser from './NavUser';
import NavUser from './NavUser';
import NavCard from './NavCard';
import Navigation from './Navigation';
import DrawerLanguage from './DrawerLanguage';
import SimpleBar from 'components/third-party/SimpleBar';
import { useSelector } from 'store';

// ==============================|| DRAWER CONTENT ||============================== //

const DrawerContent = () => {
  const theme = useTheme();
  const matchDownMD = useMediaQuery(theme.breakpoints.down('lg'));

  const { drawerOpen } = useSelector((state) => state.menu);

  // SimpleBar's own root is `height: 100%`, which without a sized parent resolves against the
  // whole drawer paper - the language row and user card then push past the bottom and the paper
  // grows its own native scrollbar. Claiming the leftover space here (flex + minHeight 0) keeps
  // the nav list the only scrollable region.
  return (
    <Box sx={{ flex: '1 1 auto', minHeight: 0, display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
      <Box sx={{ flex: '1 1 auto', minHeight: 0, overflow: 'hidden' }}>
        <SimpleBar sx={{ '& .simplebar-content': { display: 'flex', flexDirection: 'column' } }}>
          <>
            <Navigation />
            {drawerOpen && !matchDownMD && <NavCard />}
          </>
        </SimpleBar>
      </Box>
      <Box sx={{ flexShrink: 0 }}>
        <DrawerLanguage />
        <NavUser />
      </Box>
    </Box>
  );
};

export default DrawerContent;
